<template>
  <div class="chart" :style="{ height: height }">
  </div>
</template>

<script>
//import { echarts } from "echarts";
import * as echarts from "echarts";
require("echarts/theme/shine"); // echarts theme

const wholesaleData = require("../../data/wholesale/wholesaleData.json");

export default {

  props: [
    "meter",
    "current",
    "vectors",
    "contract",
    "projectedConsumption",
    "start",
  ],

  data() {
    return {
      chart: null,
      sidebarElm: null,
      height: "450px",
      autoResize: true,

      importData: [],
      exportData: [],
      dateData:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    };
  },

  mounted() {
    this.initChart(this.dateData);
    if (this.autoResize) {
      this.__resizeHandler = this.debounce(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
      window.addEventListener("resize", this.__resizeHandler);
    }
    this.$nextTick(function () {
      this.changeDateData(this.dateData);
        // Code that will run only after the entire view has been rendered
    });
    
    this.$root.$on("changeDateData", (dateData) => {
      console.log("HERE... test call method changeDateData of DayAheadChart with: " + dateData);
      return this.initChart(dateData);
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.__resizeHandler);
    }
    this.sidebarElm &&
      this.sidebarElm.removeEventListener(
        "transitionend",
        this.sidebarResizeHandler
      );
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    sidebarResizeHandler(e) {
      if (e.propertyName === "width") {
        this.__resizeHandler();
      }
    },
    setOptions() {
      let config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function () {
          var labelOption = {
            normal: {
              rotate: config.rotate,
              align: config.align,
              verticalAlign: config.verticalAlign,
              position: config.position,
              distance: config.distance,
            },
          };
          myChart.setOption({
            series: [
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
            ],
          });
        },
      };
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        toolbox: {
          //show: false,
        },
        xAxis: [
          {
            type: "category",
            //axisTick: { show: false },
            data: [
              "00:00",
              "01:00",
              "02:00",
              "03:00",
              "04:00",
              "05:00",
              "06:00",
              "07:00",
              "08:00",
              "09:00",
              "10:00",
              "11:00",
              "12:00",
              "13:00",
              "14:00",
              "15:00",
              "16:00",
              "17:00",
              "18:00",
              "19:00",
              "20:00",
              "21:00",
              "22:00",
              "23:00",
            ],
            scale: true,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: 'Import (MW)',
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              color: "black",
              fontSize: 12,
              formatter: function(d) {
                //return d.name + ' ' + d.data;
                return d.data;
              }
            },
            data: this.importData

          },
          {
            name: 'Export (MW)',
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              color: "black",
              fontSize: 12,
              formatter: function(d) {
                //return d.name + ' ' + d.data;
                return d.data;
              }
            },
            data: this.exportData
          },
        ],
      });
    },

    initChart(dateData) {
      this.getIntraDayData(dateData);
      this.chart = echarts.init(this.$el, "shine");
      this.setOptions();
    },

    debounce(func, wait, immediate) {
      let timeout, args, context, timestamp, result;
      const later = function () {
        // According to the last trigger interval
        const last = new Date().getTime() - timestamp;
        // The last time the wrapped function was called, the interval is last less than the set time interval wait
        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          // If it is set to immediate===true, since the start boundary has already been called, there is no need to call it here.
          if (!immediate) {
            result = func.apply(context, args);
            if (!timeout) {
              context = args = null;
            }
          }
        }
      };
      return function (...args) {
        context = this;
        timestamp = new Date().getTime();
        const callNow = immediate && !timeout;
        // If the delay does not exist, reset the delay
        if (!timeout) {
          timeout = setTimeout(later, wait);
        }
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }
        return result;
      };
    },

    changeDateData(e) {
      this.dateData = e;
      console.log("HERE... change dateData of DayAheadChart: "+this.dateData)
      this.getDayAheadData(this.dateData)
    },

    getIntraDayData(dateData) {
      console.log("Test dateData: "+dateData)
    
      this.importData = [];
      this.exportData = [];
      for (var i = 0; i < wholesaleData.length; i++) {
        
        if (wholesaleData[i].date == dateData) {
          for (var j = 0; j < wholesaleData[i].importData.length; j++) {
            this.importData.push(wholesaleData[i].importData[j]);
            this.exportData.push(wholesaleData[i].exportData[j]);
          }
        }
      }
    
      console.log("HERE... dayAheadData: " + this.dayAheadData);
    },
  },

  updated() {
    // Fired every second, should always be true
    this.dateData
    this.importData
    this.exportData
  },
};
</script>

<style lang="scss">
.chart-filter {
  position: absolute;
  top: 30px;
  left: 200px;
  font-size: 30px;
}
</style>